import { microAppsConfig } from "./microAppsConfig"
import { registerMicroApps, start } from 'qiankun';

export const MicroAppStart = function (){
    registerMicroApps(microAppsConfig);
    start({
        prefetch: "all",
        sandbox: false
    });
}